import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Image from "next/image";

const CourseCarousel = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/getcourses`;


        const res = await fetch(endpoint, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });


        const data = await res.json();


        if (res.ok && data.courses) {
          setCourses(data.courses);
        } else {
          console.error("Failed to load courses:", data.message || data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, []);

  return (
    <Swiper
      className="swiper course-carousel rbt-arrow-between rbt-dot-bottom-center pb--20 icon-bg-primary"
      slidesPerView={1}
      spaceBetween={30}
      modules={[Navigation, Pagination]}
      pagination={{
        el: ".rbt-swiper-pagination",
        clickable: true,
      }}
      navigation={{
        nextEl: ".rbt-arrow-right",
        prevEl: ".rbt-arrow-left",
      }}
      breakpoints={{
        481: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      }}
    >
      {courses.slice(0, 10).map((course, index) => {
        const courseId = course._id || index;
        const courseTitle = (
          course.courseTitle || "Untitled Course"
        ).toUpperCase();
        const courseImageSrc = course.courseThumbnail
          ? `${process.env.NEXT_PUBLIC_API_URL}/uploads/${course.courseThumbnail}`
          : "/images/course/coursedefault.jpg";
        // const instructorImageSrc = course.instructor?.id
        //   ? `${process.env.NEXT_PUBLIC_API_URL}/uploads/${course.instructor.id}`
        //   : "/images/course/coursedefault.jpg";

        const instructorImageSrc =  "/images/instructor/instructor1.jpg";

        return (
          <SwiperSlide style={{ marginBottom: "30px" }} key={courseId}>
            <div className="single-slide">
              <div
                className="rbt-card course-card variation-01 rbt-hover"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="rbt-card-img" style={{ flexShrink: 0 }}>
                  <Link href={`/course-details/${courseId}`} className="block">
                    <Image
                      className=""
                      src={
                        course?.courseThumbnail
                          ? `${process.env.NEXT_PUBLIC_API_URL}/uploads/${course.courseThumbnail}`
                          : "/images/course/coursedefault.jpg"
                      }
                      width={350}
                      height={400}
                      alt="Card image"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                    {course.discountPrice && (
                      <div className="rbt-badge-3 bg-white">
                        <span>-{course.discountPrice}%</span>
                        <span>Off</span>
                      </div>
                    )}
                  </Link>
                </div>

                <div
                  className="rbt-card-body"
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    padding: "20px",
                  }}
                >
                  <div style={{ minHeight: "60px", marginBottom: "15px" }}>
                    <h5
                      className="rbt-card-title"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.4",
                        margin: 0,
                      }}
                    >
                      <Link href={`/course-details/${courseId}`}>
                        {courseTitle}
                      </Link>
                    </h5>
                  </div>

                  <div style={{ minHeight: "120px", marginBottom: "15px" }}>
                    <p
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                      className="rbt-card-text"
                    >
                      {course.aboutCourse ||
                        "Course description not available."}
                    </p>
                  </div>

                  {/* Author Section - Fixed Height */}
                  <div
                    className="rbt-author-meta"
                    style={{ minHeight: "50px", marginBottom: "15px" }}
                  >
                    <div className="rbt-avater">
                      <Link href={`/profile/${course.instructor?.id}`}>
                        <Image
                          src={instructorImageSrc}
                          width={33}
                          height={33}
                          alt={course.instructor?.username[0] || "Instructor"}
                          style={{ borderRadius: "50%", objectFit: "cover" }}
                        />
                      </Link>
                    </div>
                    <div className="rbt-author-info">
                      By{" "}
                      <Link href={`/profile/${course.instructor?.id}`}>
                        {course.instructor?.username || "Unknown Instructor"}
                      </Link>
                    </div>
                  </div>

                  {/* Bottom Section - Always at bottom */}
                  <div
                    className="rbt-card-bottom"
                    style={{ marginTop: "auto", paddingTop: "15px" }}
                  >
                    <div className="rbt-price">
                      <span className="current-price">
                        ₹{course.regularPrice || "0"}
                      </span>
                      {course.discountPrice && (
                        <span className="off-price">
                          ₹{course.discountPrice}
                        </span>
                      )}
                    </div>
                    <Link
                      className="rbt-btn-link"
                      href={`/course-details/${courseId}`}
                    >
                      View details <i className="feather-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        );
      })}

      <div className="rbt-swiper-arrow rbt-arrow-left">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-left"></i>
          <i className="rbt-icon-top feather-arrow-left"></i>
        </div>
      </div>

      <div className="rbt-swiper-arrow rbt-arrow-right">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-right"></i>
          <i className="rbt-icon-top feather-arrow-right"></i>
        </div>
      </div>

      <div className="rbt-swiper-pagination" style={{ bottom: "0" }}></div>
    </Swiper>
  );
};

export default CourseCarousel;
